import { createAction, props } from '@ngrx/store';
import { IApproveBankProofDocumentRequest, IApproveBankProofDocumentResponse, IBankProofDocument, IRejectBankProofDocumentRequest, IRejectBankProofDocumentResponse } from '../models/bank-proof-documents.model';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';

// Load Current Bank Proof Documents
export const loadCurrentBankProofDocuments = createAction(
  '[BankProofDocuments] Load Current BankProof Documents',
  props<{ customerId: string, bankAccountId: string }>()
);

export const loadCurrentBankProofDocumentsSuccess = createAction(
  '[BankProofDocuments] Load Current BankProof Documents Success',
  props<{ response: IBankProofDocument }>()
);

export const loadCurrentBankProofDocumentsFailure = createAction(
  '[BankProofDocuments] Load Current BankProof Documents Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

/** Clears current + archived proof document UI state (e.g. all banks removed). */
export const clearBankProofDocumentsUiState = createAction('[BankProofDocuments] Clear UI state');

// Load Archived Bank Proof Documents
export const loadArchivedBankProofDocuments = createAction(
  '[BankProofDocuments] Load Archived BankProof Documents',
  props<{ customerId: string, bankAccountId: string }>()
);

export const loadArchivedBankProofDocumentsSuccess = createAction(
  '[BankProofDocuments] Load Archived BankProof Documents Success',
  props<{ response: IBankProofDocument[] }>()
);

export const loadArchivedBankProofDocumentsFailure = createAction(
  '[BankProofDocuments] Load Archived BankProof Documents Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);


//APPROVE BankProof
export const approveBankProofDocumentRequest = createAction(
  '[ApproveBankProof] Load ApproveBankProof Document',
  props<{ request: IApproveBankProofDocumentRequest }>()
);

export const approveBankProofDocumentResponse = createAction(
  '[ApproveBankProof] Load ApproveBankProof Document Success',
  props<{ response: IApproveBankProofDocumentResponse }>()
);

export const approveBankProofDocumentFailure = createAction(
  '[ApproveBankProof] Load BankProof Document Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

//REJECT BankProof
export const rejectBankProofDocumentRequest = createAction('[BankProof] Load reject BankProof Document', props<{ request: IRejectBankProofDocumentRequest }>());

export const rejectBankProofDocumentResponse = createAction(
  '[BankProof] Load reject BankProof Document Success',
  props<{ response: IRejectBankProofDocumentResponse }>()
);

export const rejectBankProofDocumentFailure = createAction(
  '[BankProof] Load reject BankProof Document Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);